module.exports = __webpack_public_path__ + "img/geod_10.3efc6f84.jpg";